module.exports = __webpack_public_path__ + "assets/images/games/atlas_chicken-game-1.156be9a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/games/chicken-game/atlas_chicken-game-1.png
// module id = 668
// module chunks = 1